import React, { Component } from 'react'
import {push as changeURL} from 'react-router-redux';
import mapDispatch from '~/misc/mapDispatch';
import {connect} from 'react-redux';
import includes from 'lodash/includes';
class UserDispatcher extends Component {
  componentWillReceiveProps(nextProps){
    if (nextProps.account && nextProps.account.userInfo && nextProps.account.userInfo.data) {
      if(this.showUser()) {
        this.props.goToAccount();
      }else {
        this.props.goToFreeAccount();
      }
    }
    
  }
  showUser = () => {
    const {userInfo} = this.props.account;
    if (userInfo.data.userRole && (includes(userInfo.data.userRole.toLocaleLowerCase(), 'user') || includes(userInfo.data.userRole.toLocaleLowerCase(), 'admin'))) {
      return true;
    }
    return false;
  }
  render() {
    return(
      <div></div>
    )
  }
}


export default connect(
  ({account, user}) => ({account, user}),
  mapDispatch({
    goToAccount: () => changeURL('/my-account'),
    goToFreeAccount: () => changeURL('/free-account'),
  })
)(UserDispatcher);


// WEBPACK FOOTER //
// ./src/components/pages/UserDispatcher/index.js